import { Utility } from './../../shared/entities/utils';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CoilSheet, Graph } from '../../shared/entities/coilSheet';
import { Order } from '../../shared/entities/order';
import { TagModule } from 'primeng/tag';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';

@Component({
  selector: 'app-coil-detail',
  standalone: true,
  imports: [
    CommonModule,
    TagModule,
    MatIconModule
  ],
  providers: [DatePipe],
  templateUrl: './coil-detail.component.html',
  styleUrl: './coil-detail.component.scss'
})
export class CoilDetailComponent {
  @Input()
  coil: CoilSheet = {};

  @Input()
  order: Order = {};

  @Input()
  hideTitle: boolean = false;

  @Input()
  hideOrderNumber: boolean = false;

  @Input()
  hideOrderOverview: boolean = false;

  @Output()
  viewOrderDetail: EventEmitter<any> = new EventEmitter();

  regionMeasurementUnits: any = {};
  regionUnit: string = '';

  constructor(private measurementsDataService: MeasurementsDataService) {
    this.regionMeasurementUnits = this.measurementsDataService.regionMeasurementUnits();
    this.measurementsDataService.getMeasurementsData.subscribe(unit => this.regionUnit = unit);
  }


  get showMechanicalProp() {
    return this.coil?.mechanicalPropertiesSampleLocation || this.coil?.tensileStrength || this.coil?.yieldStrength;
  }

  get salesOrderNumber() {
    if (this.coil?.salesOrderNumber) {
      return this.coil?.salesOrderNumber;
    } else {
      return this.order?.customerOrderNumber
    }
  }

  get orderId() {
    if (this.coil?.salesOrderNumber) {
      return this.coil?.salesOrderNumber;
    } else {
      return this.order?.salesOrderNumber;
    }
  }

  get orderDate() {
    if (this.coil.orderDate) {
      return Utility.formatDate(this.coil?.orderDate);
    } else {
      return Utility.formatDate(this.order?.orderDate);
    }
  }


  get widthTolerance() {

    if (this.coil.widthUpperTolerance != null && this.coil.widthUpperTolerance != undefined &&
      this.coil.widthLowerTolerance != null && this.coil.widthLowerTolerance != undefined &&
      this.coil.orderWidth != null && this.coil.orderWidth != undefined) {
        if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
          const upperTolerance = Number(Math.round((this.coil.widthUpperTolerance + Utility.convertMillimeterToInch(this.coil.orderWidth ))* 1000) / 1000).toFixed(3);
          const lowerTolerance = Number(Math.round((Utility.convertMillimeterToInch(this.coil.orderWidth) - this.coil.widthLowerTolerance) * 1000) / 1000).toFixed(3);
          return ` ${lowerTolerance} - ${upperTolerance} ${this.regionMeasurementUnits.width_thickness}`;
        }else{
          const upperTolerance = Number(Math.round((this.coil.widthUpperTolerance + this.coil.orderWidth) * 1000) / 1000).toFixed(2);
      const lowerTolerance = Number(Math.round((this.coil.orderWidth - this.coil.widthLowerTolerance) * 1000) / 1000).toFixed(2);
      return ` ${lowerTolerance} - ${upperTolerance} ${this.regionMeasurementUnits.width_thickness}`;
        }
    } else {
      return ' ';
    }
  }

  get thicknessTolerance() {
    if (this.coil.thicknessUpperTolerance != null && this.coil.thicknessUpperTolerance != undefined &&
      this.coil.thicknessLowerTolerance != null && this.coil.thicknessLowerTolerance != undefined &&
      this.coil.orderThickness != null && this.coil.orderThickness != undefined) {
        if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
          const upperTolerance = Number(Math.round((this.coil.thicknessUpperTolerance + Utility.convertMillimeterToInch(this.coil.orderThickness)) * 1000) / 1000).toFixed(3);
      const lowerTolerance = Number(Math.round((Utility.convertMillimeterToInch(this.coil.orderThickness) - this.coil.thicknessLowerTolerance) * 1000) / 1000).toFixed(3);
      return ` ${lowerTolerance} - ${upperTolerance} ${this.regionMeasurementUnits.width_thickness}`;
        }else{
          const upperTolerance = Number(Math.round((this.coil.thicknessUpperTolerance + this.coil.orderThickness) * 1000) / 1000).toFixed(2);
          const lowerTolerance = Number(Math.round((this.coil.orderThickness - this.coil.thicknessLowerTolerance) * 1000) / 1000).toFixed(2);
          return ` ${lowerTolerance} - ${upperTolerance} ${this.regionMeasurementUnits.width_thickness}`;
        }
      
    } else {
      return ' ';
    }
  }
  get Rp() {
    if (this.coil.rp) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMpaToPsi(this.coil.rp)} ${this.regionMeasurementUnits.rp}`;
      } else {
        return `${this.coil.rp} ${this.regionMeasurementUnits.rp}`;
      }
    } else {
      return '';
    }
  }
  get orderWidth() {
    if (this.coil.orderWidth) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMillimeterToInch(this.coil.orderWidth)} ${this.regionMeasurementUnits.width_thickness}`;
      } else {
        return `${Math.trunc(this.coil.orderWidth)} ${this.regionMeasurementUnits.width_thickness}`;
      }
    } else {
      return '';
    }
  }
  get orderThickness() {
    if (this.coil.orderThickness) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMillimeterToInch(this.coil.orderThickness).toFixed(3)} ${this.regionMeasurementUnits.width_thickness}`;
      } else {
        return `${this.coil.orderThickness.toFixed(2)} ${this.regionMeasurementUnits.width_thickness}`;
      }
    } else {
      return '';
    }
  }
  get Rm() {
    if (this.coil.rm) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMpaToPsi(this.coil.rm)} ${this.regionMeasurementUnits.rm}`;
      } else {
        return `${this.coil.rm} ${this.regionMeasurementUnits.rm}`;
      }
    } else {
      return '';
    }
  }

  get ReL() {
    if (this.coil.reL) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMpaToPsi(this.coil.reL)} ${this.regionMeasurementUnits.reL}`;
      } else {
        return `${this.coil.reL} ${this.regionMeasurementUnits.reL}`;
      }
    } else {
      return '';
    }
  }

  get ReH() {
    if (this.coil.reH) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        return `${Utility.convertMpaToPsi(this.coil.reH)} ${this.regionMeasurementUnits.reH}`;
      } else {
        return `${this.coil.reH} ${this.regionMeasurementUnits.reH}`;
      }
    } else {
      return '';
    }
  }

  formatDate(date: Date | undefined) {
    if (date) {
      return date?.toString()?.split('-')?.reverse()?.join('-');
    } else {
      return '';
    }
  }

}